import Copy from "@/components/copy";
import { useUser } from "@/zustand/store";
const TwoFactor = () => {
  const { user } = useUser();
  return (
    <div className="text-dark-text-50">
      <h3>Two-Factor Authentication</h3>
      {/* The Auxiliary/3 circle is part of the asset, so this needs no wrapper
          background — the old `2fa-ice.svg` relied on one. */}
      <img className="mt-6 size-12" src="/icons/2fa-badge.svg" alt="" />
      <h3 className="mt-4">Add to your authenticator app</h3>
      <div className="bg-dark-card-5 border-gradient-aux-4 my-4 flex h-12 w-full items-center justify-center gap-4 rounded px-4 py-2 text-xs">
        <span>{user.authenticatorSecret}</span>
        <Copy icon="/icons/copy-light.svg" text={user.authenticatorSecret} />
      </div>
      <p className="text-[10px] ">
        Copy the token above and add it to you authenticator app, you’ll be
        required to use your authenticator code to complete your registration.
      </p>
    </div>
  );
};

export default TwoFactor;
